import { type ReactElement, type ReactNode } from "react";

import { pixels } from "../Variables";
import { FlexDiv } from "./FlexDiv";
import { SimpleLabelField } from "./LabelField";

export interface Info {
  label: string;
  value: string | ReactNode | undefined;
}

interface CustomerInfoProps {
  info: Info[];
  title?: ReactElement<any>;
  showTitle?: boolean;
}

export const InfoBox = ({ info, title, showTitle }: CustomerInfoProps) => {
  if (!info) {
    return null;
  }

  return (
    <>
      {showTitle && title}
      <FlexDiv
        flexDirection="column"
        gap={pixels.space4}
        margin={`${pixels.space10} 0 0 0`}
      >
        {info.map((item) => (
          <SimpleLabelField
            label={item.label}
            value={item.value}
            key={`infobox-${item.label}`}
          />
        ))}
      </FlexDiv>
    </>
  );
};
